var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_setup.status,attrs:{"title":_vm.valid.error},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', $event)}}},[(_vm.valid.complete)?_c('span',[_c(_setup.FontAwesomeIcon,{attrs:{"icon":"check"}})],1):_vm._e(),_vm._v(" "+_vm._s(_setup.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }